import { readableColor } from 'polished';

export default readableColor;
